import React, { Suspense, lazy } from "react";
import styles from "./MainContent.module.css";
import { useInView } from "react-intersection-observer";
 import Layout from "./Layout";
import ContactUs from "./ContactUs";

const FAQ = lazy(() => import("./FAQ"));

const LazyComponent = ({ children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div
      ref={ref}
      className={`${styles.lazyComponent} ${inView ? styles.inView : ""}`}
    >
      {inView ? (
        <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

// Brazil v10 components
import BrazilHero from './BrazilHero';
import AmbientParticlesLayer from 'src/components/br/AmbientParticlesLayer';
import { useLocale } from './LocaleContext';
import ScrollCue from './ScrollCue';

const AboutContent = () => {
  const { locale, toggleLocale } = useLocale();
  
  return (
    <div className={styles.mainContainer} style={{ position:'relative', background:'linear-gradient(120deg,#0C0D0E,#101F17 35%, #1E3C2E 60%, #0C0D0E)' }}>
      <AmbientParticlesLayer count={28} />
      {/* Narrative Flow */}
      
      <div style={{ marginBottom:'3.5rem', position:'relative' }}>
        <ScrollCue />
        <Suspense fallback={<div>Loading...</div>}>
          <BrazilHero locale={locale} toggleLocale={toggleLocale} />
        </Suspense>
      </div>
    
      {/* Legacy (tokenization, market, roadmap, faq) lazily loaded */}
      <LazyComponent>
        <div className={styles.content}>
        
          <div style={{ marginBottom:'3.5rem', position:'relative' }}>
            <FAQ />
          </div>
        </div>
      </LazyComponent>
      {/* Contact Section */}
      <div className={styles.heroSection} style={{ background:'none', marginTop:60 }}>
        <Layout>
          <div className={styles.contentContainer}>
            <ContactUs />
          </div>
        </Layout>
      </div>
    </div>
  );
};

const About = () => (<AboutContent />);

export default About;
